import React, { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WrapperComponent } from '../Common/WrapperComponent';
import OrderRequirements from './OrderRequirements';
import AdditionalRequirementsOne from './AdditionalRequirementsOne';
import { WrapperComponentWithSubSections } from '../Common/WrapperComponentWithSubSections';
import AdditionalRequirementsTwo from './AdditionalRequirementsTwo';
import OrderDetailsOne from './OrderDetailsOne';
import OrderDetailsTwo from './OrderDetailsTwo';
import { WrapperForExperience } from '../Common/WrapperForExperience';
import Experiences from './Experiences';
import { useSelector } from 'react-redux';
import { selectSkillsetDataUIFormat } from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { selectOrderDetailsUIView } from '@AMIEWEB/Order/Store/Order.selectors';
import { ISkillSetGroup } from '@AMIEWEB/Facility/FacilityStore/Facility.model';
import { transformSkillSetGroupData } from '@AMIEWEB/Order/OrderCreationForm/Components/UnitDetail/UnitDetailDataTransformer';
import Qualifications from './Qualification/Qualifications';
import { EditIcon } from '@AMIEWEB/NewOrder/OrderDetails/OrderSummary';

export const OrderPreview = ({ isNewOrderCreation }: { isNewOrderCreation: boolean }) => {
  const { t } = useTranslation();
  const skillSetGroupsOrderStore = useSelector(selectOrderDetailsUIView);
  const skillSetGroupsStore = useSelector(selectSkillsetDataUIFormat);
  const [orderCreationEdit, setOrderCreationEdit] = useState(false);
  const [isOpenFromPreview, setIsOpenFromPreview] = useState(false);
  let skillSetGroups: ISkillSetGroup;

  if (isNewOrderCreation) {
    skillSetGroups = transformSkillSetGroupData(skillSetGroupsStore);
  } else {
    skillSetGroups = skillSetGroupsOrderStore.orderDetails.skillSetGroup;
  }
  const handleEditClick = () => {
    setOrderCreationEdit(true);
    setIsOpenFromPreview(true);
  };

  const handleModalClose = () => {
    setIsOpenFromPreview(false);
  };

  return (
    <Grid>
      <Box>
        <Typography variant="h6" fontSize={'20px'} fontWeight={'normal'} padding={'12px 0px'}>
          {t('order.newOrderCreation.tabs.previewAndSubmit')}
        </Typography>
        <Grid container xs={12} spacing={2} margin={'0px'}>
          <Grid xs={4} paddingRight={'12px'}>
            <WrapperComponent
              title={t('order.newOrderCreation.tabs.qualifications')}
              children={
                <Qualifications
                  isNewOrderCreation={true}
                  orderCreationEdit={orderCreationEdit}
                  isOpenFromPreview={isOpenFromPreview}
                  handleCloseModal={handleModalClose}
                />
              }
              icon={<EditIcon handleEditOrder={handleEditClick} />}
            />
            <WrapperComponent
              title={t('order.newOrderCreation.tabs.orderRequirements')}
              children={<OrderRequirements isNewOrderCreation={isNewOrderCreation} />}
            />
          </Grid>
          <Grid xs={8}>
            <WrapperForExperience
              title={t('facility.units.experience.title', {
                expCount: skillSetGroups?.groups[0]?.skillsets?.length ?? 0,
              })}
              children={<Experiences isNewOrderCreation={isNewOrderCreation} />}
            />

            <WrapperComponentWithSubSections
              title={t('order.newOrderCreation.tabs.orderDetails')}
              childrenOne={<OrderDetailsOne isNewOrderCreation={isNewOrderCreation} />}
              childrenTwo={<OrderDetailsTwo isNewOrderCreation={isNewOrderCreation} />}
            />
            <WrapperComponentWithSubSections
              title={t('placement.profile.tabs.additionalRequirements')}
              childrenOne={<AdditionalRequirementsOne isNewOrderCreation={isNewOrderCreation} />}
              childrenTwo={<AdditionalRequirementsTwo isNewOrderCreation={isNewOrderCreation} />}
            />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};
